// Delivery promise shown on the PDP. Numbers come from the spec (US 5–11 days, CN 7–15 business days,
// +1–3 processing days). CN counts business days; US counts calendar days (USPS domestic).
export function addBusinessDays(date, n) {
  const d = new Date(date);
  let left = n;
  while (left > 0) {
    d.setDate(d.getDate() + 1);
    const day = d.getDay();
    if (day !== 0 && day !== 6) left--;
  }
  return d;
}

function addDays(date, n) { const d = new Date(date); d.setDate(d.getDate() + n); return d; }

export function deliveryWindow(shipsFrom, from = new Date()) {
  if (shipsFrom === 'US') return { start: addDays(from, 1 + 5), end: addDays(from, 3 + 11) };
  return { start: addBusinessDays(from, 1 + 7), end: addBusinessDays(from, 3 + 15) };
}

export function formatWindow({ start, end }, locale = 'en-US') {
  const f = new Intl.DateTimeFormat(locale, { month: 'short', day: 'numeric' });
  return `${f.format(start)} – ${f.format(end)}`;
}

// True once the shopper's local date is after the cutoff ("YYYY-MM-DD", the
// block setting). The cutoff day itself still counts. Bad input never hides.
export function cutoffPassed(cutoff, now = new Date()) {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(cutoff ?? '').trim());
  if (!m) return false;
  const today = now.getFullYear() * 10000 + (now.getMonth() + 1) * 100 + now.getDate();
  return today > Number(m[1] + m[2] + m[3]);
}

if (typeof customElements !== 'undefined' && !customElements.get('gm-delivery')) {
  customElements.define('gm-delivery', class extends HTMLElement {
    connectedCallback() {
      const out = this.querySelector('[data-window]');
      if (out) {
        // Month names follow the page language (<html lang>); falls back to en-US.
        let locale = document.documentElement.lang || 'en-US';
        try { new Intl.DateTimeFormat(locale); } catch { locale = 'en-US'; }
        out.textContent = formatWindow(deliveryWindow(this.dataset.shipsFrom), locale);
      }
      const cutoff = this.querySelector('[data-cutoff]');
      if (cutoff && cutoffPassed(cutoff.dataset.cutoff)) cutoff.hidden = true;
    }
  });
}
